import { useAct } from 'FlowBuilder/store'
import TextField from 'Shared/components/TextField'
import './ShareSettingsForm.scoped.scss'

export default function ShareSettingsForm() {
  const act = useAct()
  
  const {settings} = useSel(s => s.builder?.flow || {})

  function settingUpdater(key) {
    return (value) => {
      act.builder.updateFlowSetting(key, value)
    }
  }

  return (
    <div>
      <form>
        <TextField 
          label="Share title" 
          value={settings.shareTitle} 
          onChange={settingUpdater('shareTitle')} 
        />

        <TextField 
          label="Share description" 
          value={settings.shareDescription} 
          onChange={settingUpdater('shareDescription')} 
        />

        <TextField 
          label="Share image URL" 
          value={settings.shareImageUrl} 
          onChange={settingUpdater('shareImageUrl')} 
        />
        
        <TextField 
          label="Share reason" 
          value={settings.shareReasonText} 
          onChange={settingUpdater('shareReasonText')} 
        />
      </form>
      <div className="share-preview">
        <img src={settings.shareImageUrl} alt="Share preview" />
        <div className="share-info">
          <h4>{settings.shareTitle}</h4>
          <p>{settings.shareDescription}</p>
        </div>
      </div>
    </div>
  )
}
